// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Router from 'vue-router'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
import './styles/index.css'
import './styles/variable.less'
import axios from '@/utils/request.js'
import utils from './utils/utils'// 时间转换器
import { getStoredLocale, applyElementLocale, syncLocaleFromUrl } from './utils/lang'
import enLocale from './i18n/en-US'
import zhLocale from './i18n/zh-CN'
import FastClick from 'fastclick'
FastClick.attach(document.body);
Vue.prototype.utils = utils
Vue.use(VueI18n)
const messages = {
  en: {
    ...enLocale
  },
  zh_CN: {
    ...zhLocale
  }
}

const i18n = new VueI18n({

  locale: getStoredLocale(),
  messages,
  silentTranslationWarn: true
})
// 实例化i18n并引入语言文件。
Vue.config.productionTip = false
applyElementLocale(getStoredLocale())
Vue.use(ElementUI);
Vue.prototype.$http = axios

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  syncLocaleFromUrl(i18n, to.query)
  next()
})
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  i18n, // 挂载
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js